/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAppRouteImport } from './routes/_authed/_app'
import { Route as DevUiRouteImport } from './routes/dev.ui'
import { Route as AuthedAppGuideRouteImport } from './routes/_authed/_app.guide'
import { Route as AuthedTTenantSlugRouteImport } from './routes/_authed/t/$tenantSlug'
import { Route as AuthedAppAdminIndexRouteImport } from './routes/_authed/_app.admin.index'
import { Route as AuthedAppSettingsIndexRouteImport } from './routes/_authed/_app.settings.index'
import { Route as AuthedAppSettingsHotkeysRouteImport } from './routes/_authed/_app.settings.hotkeys'
import { Route as AuthedAppSettingsInterfaceRouteImport } from './routes/_authed/_app.settings.interface'
import { Route as AuthedTTenantSlugIndexRouteImport } from './routes/_authed/t/$tenantSlug/index'
import { Route as AuthedTTenantSlugShellRouteImport } from './routes/_authed/t/$tenantSlug/_shell'
import { Route as AuthedAppAdminOrganizationsOrgIdRouteImport } from './routes/_authed/_app.admin.organizations.$orgId'
import { Route as AuthedTTenantSlugShellAlarmsRouteImport } from './routes/_authed/t/$tenantSlug/_shell.alarms'
import { Route as AuthedTTenantSlugShellConnectorsRouteImport } from './routes/_authed/t/$tenantSlug/_shell.connectors'
import { Route as AuthedTTenantSlugShellDocumentsRouteImport } from './routes/_authed/t/$tenantSlug/_shell.documents'
import { Route as AuthedTTenantSlugShellEmployeesRouteImport } from './routes/_authed/t/$tenantSlug/_shell.employees'
import { Route as AuthedTTenantSlugSSectionIdRouteImport } from './routes/_authed/t/$tenantSlug/s.$sectionId'
import { Route as AuthedTTenantSlugShellConnectorsIndexRouteImport } from './routes/_authed/t/$tenantSlug/_shell.connectors.index'
import { Route as AuthedTTenantSlugShellConnectorsConnectorIdRouteImport } from './routes/_authed/t/$tenantSlug/_shell.connectors.$connectorId'
import { Route as AuthedTTenantSlugShellDashboardEditRouteImport } from './routes/_authed/t/$tenantSlug/_shell.dashboard.edit'
import { Route as AuthedTTenantSlugShellDevicesCalibrationRouteImport } from './routes/_authed/t/$tenantSlug/_shell.devices.calibration'
import { Route as AuthedTTenantSlugShellDevicesCategoriesRouteImport } from './routes/_authed/t/$tenantSlug/_shell.devices.categories'
import { Route as AuthedTTenantSlugShellDevicesChartsRouteImport } from './routes/_authed/t/$tenantSlug/_shell.devices.charts'
import { Route as AuthedTTenantSlugShellDevicesConfigRouteImport } from './routes/_authed/t/$tenantSlug/_shell.devices.config'
import { Route as AuthedTTenantSlugShellDevicesInfoRouteImport } from './routes/_authed/t/$tenantSlug/_shell.devices.info'
import { Route as AuthedTTenantSlugShellDevicesLocationsRouteImport } from './routes/_authed/t/$tenantSlug/_shell.devices.locations'
import { Route as AuthedTTenantSlugShellMonitoringDevicesRouteImport } from './routes/_authed/t/$tenantSlug/_shell.monitoring.devices'
import { Route as AuthedTTenantSlugShellMonitoringPhysicalRouteImport } from './routes/_authed/t/$tenantSlug/_shell.monitoring.physical'
import { Route as AuthedTTenantSlugShellMonitoringVirtualRouteImport } from './routes/_authed/t/$tenantSlug/_shell.monitoring.virtual'
import { Route as AuthedTTenantSlugShellSectionsSectionIdEditRouteImport } from './routes/_authed/t/$tenantSlug/_shell.sections.$sectionId.edit'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAppRoute = AuthedAppRouteImport.update({
  id: '/_app',
  getParentRoute: () => AuthedRoute,
} as any)
const DevUiRoute = DevUiRouteImport.update({
  id: '/dev/ui',
  path: '/dev/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAppGuideRoute = AuthedAppGuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => AuthedAppRoute,
} as any)
const AuthedTTenantSlugRoute = AuthedTTenantSlugRouteImport.update({
  id: '/t/$tenantSlug',
  path: '/t/$tenantSlug',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAppAdminIndexRoute = AuthedAppAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AuthedAppRoute,
} as any)
const AuthedAppSettingsIndexRoute = AuthedAppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthedAppRoute,
} as any)
const AuthedAppSettingsHotkeysRoute =
  AuthedAppSettingsHotkeysRouteImport.update({
    id: '/settings/hotkeys',
    path: '/settings/hotkeys',
    getParentRoute: () => AuthedAppRoute,
  } as any)
const AuthedAppSettingsInterfaceRoute =
  AuthedAppSettingsInterfaceRouteImport.update({
    id: '/settings/interface',
    path: '/settings/interface',
    getParentRoute: () => AuthedAppRoute,
  } as any)
const AuthedTTenantSlugIndexRoute = AuthedTTenantSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedTTenantSlugRoute,
} as any)
const AuthedTTenantSlugShellRoute = AuthedTTenantSlugShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => AuthedTTenantSlugRoute,
} as any)
const AuthedAppAdminOrganizationsOrgIdRoute =
  AuthedAppAdminOrganizationsOrgIdRouteImport.update({
    id: '/admin/organizations/$orgId',
    path: '/admin/organizations/$orgId',
    getParentRoute: () => AuthedAppRoute,
  } as any)
const AuthedTTenantSlugShellAlarmsRoute =
  AuthedTTenantSlugShellAlarmsRouteImport.update({
    id: '/alarms',
    path: '/alarms',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellConnectorsRoute =
  AuthedTTenantSlugShellConnectorsRouteImport.update({
    id: '/connectors',
    path: '/connectors',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellDocumentsRoute =
  AuthedTTenantSlugShellDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellEmployeesRoute =
  AuthedTTenantSlugShellEmployeesRouteImport.update({
    id: '/employees',
    path: '/employees',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugSSectionIdRoute =
  AuthedTTenantSlugSSectionIdRouteImport.update({
    id: '/s/$sectionId',
    path: '/s/$sectionId',
    getParentRoute: () => AuthedTTenantSlugRoute,
  } as any)
const AuthedTTenantSlugShellConnectorsIndexRoute =
  AuthedTTenantSlugShellConnectorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedTTenantSlugShellConnectorsRoute,
  } as any)
const AuthedTTenantSlugShellConnectorsConnectorIdRoute =
  AuthedTTenantSlugShellConnectorsConnectorIdRouteImport.update({
    id: '/$connectorId',
    path: '/$connectorId',
    getParentRoute: () => AuthedTTenantSlugShellConnectorsRoute,
  } as any)
const AuthedTTenantSlugShellDashboardEditRoute =
  AuthedTTenantSlugShellDashboardEditRouteImport.update({
    id: '/dashboard/edit',
    path: '/dashboard/edit',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellDevicesCalibrationRoute =
  AuthedTTenantSlugShellDevicesCalibrationRouteImport.update({
    id: '/devices/calibration',
    path: '/devices/calibration',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellDevicesCategoriesRoute =
  AuthedTTenantSlugShellDevicesCategoriesRouteImport.update({
    id: '/devices/categories',
    path: '/devices/categories',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellDevicesChartsRoute =
  AuthedTTenantSlugShellDevicesChartsRouteImport.update({
    id: '/devices/charts',
    path: '/devices/charts',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellDevicesConfigRoute =
  AuthedTTenantSlugShellDevicesConfigRouteImport.update({
    id: '/devices/config',
    path: '/devices/config',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellDevicesInfoRoute =
  AuthedTTenantSlugShellDevicesInfoRouteImport.update({
    id: '/devices/info',
    path: '/devices/info',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellDevicesLocationsRoute =
  AuthedTTenantSlugShellDevicesLocationsRouteImport.update({
    id: '/devices/locations',
    path: '/devices/locations',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellMonitoringDevicesRoute =
  AuthedTTenantSlugShellMonitoringDevicesRouteImport.update({
    id: '/monitoring/devices',
    path: '/monitoring/devices',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellMonitoringPhysicalRoute =
  AuthedTTenantSlugShellMonitoringPhysicalRouteImport.update({
    id: '/monitoring/physical',
    path: '/monitoring/physical',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellMonitoringVirtualRoute =
  AuthedTTenantSlugShellMonitoringVirtualRouteImport.update({
    id: '/monitoring/virtual',
    path: '/monitoring/virtual',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)
const AuthedTTenantSlugShellSectionsSectionIdEditRoute =
  AuthedTTenantSlugShellSectionsSectionIdEditRouteImport.update({
    id: '/sections/$sectionId/edit',
    path: '/sections/$sectionId/edit',
    getParentRoute: () => AuthedTTenantSlugShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/dev/ui': typeof DevUiRoute
  '/guide': typeof AuthedAppGuideRoute
  '/t/$tenantSlug': typeof AuthedTTenantSlugRouteWithChildren
  '/settings/hotkeys': typeof AuthedAppSettingsHotkeysRoute
  '/settings/interface': typeof AuthedAppSettingsInterfaceRoute
  '/admin/': typeof AuthedAppAdminIndexRoute
  '/settings/': typeof AuthedAppSettingsIndexRoute
  '/t/$tenantSlug/': typeof AuthedTTenantSlugIndexRoute
  '/admin/organizations/$orgId': typeof AuthedAppAdminOrganizationsOrgIdRoute
  '/t/$tenantSlug/alarms': typeof AuthedTTenantSlugShellAlarmsRoute
  '/t/$tenantSlug/connectors': typeof AuthedTTenantSlugShellConnectorsRouteWithChildren
  '/t/$tenantSlug/documents': typeof AuthedTTenantSlugShellDocumentsRoute
  '/t/$tenantSlug/employees': typeof AuthedTTenantSlugShellEmployeesRoute
  '/t/$tenantSlug/s/$sectionId': typeof AuthedTTenantSlugSSectionIdRoute
  '/t/$tenantSlug/connectors/$connectorId': typeof AuthedTTenantSlugShellConnectorsConnectorIdRoute
  '/t/$tenantSlug/dashboard/edit': typeof AuthedTTenantSlugShellDashboardEditRoute
  '/t/$tenantSlug/devices/calibration': typeof AuthedTTenantSlugShellDevicesCalibrationRoute
  '/t/$tenantSlug/devices/categories': typeof AuthedTTenantSlugShellDevicesCategoriesRoute
  '/t/$tenantSlug/devices/charts': typeof AuthedTTenantSlugShellDevicesChartsRoute
  '/t/$tenantSlug/devices/config': typeof AuthedTTenantSlugShellDevicesConfigRoute
  '/t/$tenantSlug/devices/info': typeof AuthedTTenantSlugShellDevicesInfoRoute
  '/t/$tenantSlug/devices/locations': typeof AuthedTTenantSlugShellDevicesLocationsRoute
  '/t/$tenantSlug/monitoring/devices': typeof AuthedTTenantSlugShellMonitoringDevicesRoute
  '/t/$tenantSlug/monitoring/physical': typeof AuthedTTenantSlugShellMonitoringPhysicalRoute
  '/t/$tenantSlug/monitoring/virtual': typeof AuthedTTenantSlugShellMonitoringVirtualRoute
  '/t/$tenantSlug/connectors/': typeof AuthedTTenantSlugShellConnectorsIndexRoute
  '/t/$tenantSlug/sections/$sectionId/edit': typeof AuthedTTenantSlugShellSectionsSectionIdEditRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthedIndexRoute
  '/dev/ui': typeof DevUiRoute
  '/guide': typeof AuthedAppGuideRoute
  '/settings/hotkeys': typeof AuthedAppSettingsHotkeysRoute
  '/settings/interface': typeof AuthedAppSettingsInterfaceRoute
  '/t/$tenantSlug': typeof AuthedTTenantSlugIndexRoute
  '/admin': typeof AuthedAppAdminIndexRoute
  '/settings': typeof AuthedAppSettingsIndexRoute
  '/admin/organizations/$orgId': typeof AuthedAppAdminOrganizationsOrgIdRoute
  '/t/$tenantSlug/alarms': typeof AuthedTTenantSlugShellAlarmsRoute
  '/t/$tenantSlug/documents': typeof AuthedTTenantSlugShellDocumentsRoute
  '/t/$tenantSlug/employees': typeof AuthedTTenantSlugShellEmployeesRoute
  '/t/$tenantSlug/s/$sectionId': typeof AuthedTTenantSlugSSectionIdRoute
  '/t/$tenantSlug/connectors/$connectorId': typeof AuthedTTenantSlugShellConnectorsConnectorIdRoute
  '/t/$tenantSlug/dashboard/edit': typeof AuthedTTenantSlugShellDashboardEditRoute
  '/t/$tenantSlug/devices/calibration': typeof AuthedTTenantSlugShellDevicesCalibrationRoute
  '/t/$tenantSlug/devices/categories': typeof AuthedTTenantSlugShellDevicesCategoriesRoute
  '/t/$tenantSlug/devices/charts': typeof AuthedTTenantSlugShellDevicesChartsRoute
  '/t/$tenantSlug/devices/config': typeof AuthedTTenantSlugShellDevicesConfigRoute
  '/t/$tenantSlug/devices/info': typeof AuthedTTenantSlugShellDevicesInfoRoute
  '/t/$tenantSlug/devices/locations': typeof AuthedTTenantSlugShellDevicesLocationsRoute
  '/t/$tenantSlug/monitoring/devices': typeof AuthedTTenantSlugShellMonitoringDevicesRoute
  '/t/$tenantSlug/monitoring/physical': typeof AuthedTTenantSlugShellMonitoringPhysicalRoute
  '/t/$tenantSlug/monitoring/virtual': typeof AuthedTTenantSlugShellMonitoringVirtualRoute
  '/t/$tenantSlug/connectors': typeof AuthedTTenantSlugShellConnectorsIndexRoute
  '/t/$tenantSlug/sections/$sectionId/edit': typeof AuthedTTenantSlugShellSectionsSectionIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/_app': typeof AuthedAppRouteWithChildren
  '/dev/ui': typeof DevUiRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/_app/guide': typeof AuthedAppGuideRoute
  '/_authed/t/$tenantSlug': typeof AuthedTTenantSlugRouteWithChildren
  '/_authed/_app/settings/hotkeys': typeof AuthedAppSettingsHotkeysRoute
  '/_authed/_app/settings/interface': typeof AuthedAppSettingsInterfaceRoute
  '/_authed/t/$tenantSlug/_shell': typeof AuthedTTenantSlugShellRouteWithChildren
  '/_authed/_app/admin/': typeof AuthedAppAdminIndexRoute
  '/_authed/_app/settings/': typeof AuthedAppSettingsIndexRoute
  '/_authed/t/$tenantSlug/': typeof AuthedTTenantSlugIndexRoute
  '/_authed/_app/admin/organizations/$orgId': typeof AuthedAppAdminOrganizationsOrgIdRoute
  '/_authed/t/$tenantSlug/_shell/alarms': typeof AuthedTTenantSlugShellAlarmsRoute
  '/_authed/t/$tenantSlug/_shell/connectors': typeof AuthedTTenantSlugShellConnectorsRouteWithChildren
  '/_authed/t/$tenantSlug/_shell/documents': typeof AuthedTTenantSlugShellDocumentsRoute
  '/_authed/t/$tenantSlug/_shell/employees': typeof AuthedTTenantSlugShellEmployeesRoute
  '/_authed/t/$tenantSlug/s/$sectionId': typeof AuthedTTenantSlugSSectionIdRoute
  '/_authed/t/$tenantSlug/_shell/connectors/$connectorId': typeof AuthedTTenantSlugShellConnectorsConnectorIdRoute
  '/_authed/t/$tenantSlug/_shell/dashboard/edit': typeof AuthedTTenantSlugShellDashboardEditRoute
  '/_authed/t/$tenantSlug/_shell/devices/calibration': typeof AuthedTTenantSlugShellDevicesCalibrationRoute
  '/_authed/t/$tenantSlug/_shell/devices/categories': typeof AuthedTTenantSlugShellDevicesCategoriesRoute
  '/_authed/t/$tenantSlug/_shell/devices/charts': typeof AuthedTTenantSlugShellDevicesChartsRoute
  '/_authed/t/$tenantSlug/_shell/devices/config': typeof AuthedTTenantSlugShellDevicesConfigRoute
  '/_authed/t/$tenantSlug/_shell/devices/info': typeof AuthedTTenantSlugShellDevicesInfoRoute
  '/_authed/t/$tenantSlug/_shell/devices/locations': typeof AuthedTTenantSlugShellDevicesLocationsRoute
  '/_authed/t/$tenantSlug/_shell/monitoring/devices': typeof AuthedTTenantSlugShellMonitoringDevicesRoute
  '/_authed/t/$tenantSlug/_shell/monitoring/physical': typeof AuthedTTenantSlugShellMonitoringPhysicalRoute
  '/_authed/t/$tenantSlug/_shell/monitoring/virtual': typeof AuthedTTenantSlugShellMonitoringVirtualRoute
  '/_authed/t/$tenantSlug/_shell/connectors/': typeof AuthedTTenantSlugShellConnectorsIndexRoute
  '/_authed/t/$tenantSlug/_shell/sections/$sectionId/edit': typeof AuthedTTenantSlugShellSectionsSectionIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dev/ui'
    | '/guide'
    | '/t/$tenantSlug'
    | '/settings/hotkeys'
    | '/settings/interface'
    | '/admin/'
    | '/settings/'
    | '/t/$tenantSlug/'
    | '/admin/organizations/$orgId'
    | '/t/$tenantSlug/alarms'
    | '/t/$tenantSlug/connectors'
    | '/t/$tenantSlug/documents'
    | '/t/$tenantSlug/employees'
    | '/t/$tenantSlug/s/$sectionId'
    | '/t/$tenantSlug/connectors/$connectorId'
    | '/t/$tenantSlug/dashboard/edit'
    | '/t/$tenantSlug/devices/calibration'
    | '/t/$tenantSlug/devices/categories'
    | '/t/$tenantSlug/devices/charts'
    | '/t/$tenantSlug/devices/config'
    | '/t/$tenantSlug/devices/info'
    | '/t/$tenantSlug/devices/locations'
    | '/t/$tenantSlug/monitoring/devices'
    | '/t/$tenantSlug/monitoring/physical'
    | '/t/$tenantSlug/monitoring/virtual'
    | '/t/$tenantSlug/connectors/'
    | '/t/$tenantSlug/sections/$sectionId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/dev/ui'
    | '/guide'
    | '/settings/hotkeys'
    | '/settings/interface'
    | '/t/$tenantSlug'
    | '/admin'
    | '/settings'
    | '/admin/organizations/$orgId'
    | '/t/$tenantSlug/alarms'
    | '/t/$tenantSlug/documents'
    | '/t/$tenantSlug/employees'
    | '/t/$tenantSlug/s/$sectionId'
    | '/t/$tenantSlug/connectors/$connectorId'
    | '/t/$tenantSlug/dashboard/edit'
    | '/t/$tenantSlug/devices/calibration'
    | '/t/$tenantSlug/devices/categories'
    | '/t/$tenantSlug/devices/charts'
    | '/t/$tenantSlug/devices/config'
    | '/t/$tenantSlug/devices/info'
    | '/t/$tenantSlug/devices/locations'
    | '/t/$tenantSlug/monitoring/devices'
    | '/t/$tenantSlug/monitoring/physical'
    | '/t/$tenantSlug/monitoring/virtual'
    | '/t/$tenantSlug/connectors'
    | '/t/$tenantSlug/sections/$sectionId/edit'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/_app'
    | '/dev/ui'
    | '/_authed/'
    | '/_authed/_app/guide'
    | '/_authed/t/$tenantSlug'
    | '/_authed/_app/settings/hotkeys'
    | '/_authed/_app/settings/interface'
    | '/_authed/t/$tenantSlug/_shell'
    | '/_authed/_app/admin/'
    | '/_authed/_app/settings/'
    | '/_authed/t/$tenantSlug/'
    | '/_authed/_app/admin/organizations/$orgId'
    | '/_authed/t/$tenantSlug/_shell/alarms'
    | '/_authed/t/$tenantSlug/_shell/connectors'
    | '/_authed/t/$tenantSlug/_shell/documents'
    | '/_authed/t/$tenantSlug/_shell/employees'
    | '/_authed/t/$tenantSlug/s/$sectionId'
    | '/_authed/t/$tenantSlug/_shell/connectors/$connectorId'
    | '/_authed/t/$tenantSlug/_shell/dashboard/edit'
    | '/_authed/t/$tenantSlug/_shell/devices/calibration'
    | '/_authed/t/$tenantSlug/_shell/devices/categories'
    | '/_authed/t/$tenantSlug/_shell/devices/charts'
    | '/_authed/t/$tenantSlug/_shell/devices/config'
    | '/_authed/t/$tenantSlug/_shell/devices/info'
    | '/_authed/t/$tenantSlug/_shell/devices/locations'
    | '/_authed/t/$tenantSlug/_shell/monitoring/devices'
    | '/_authed/t/$tenantSlug/_shell/monitoring/physical'
    | '/_authed/t/$tenantSlug/_shell/monitoring/virtual'
    | '/_authed/t/$tenantSlug/_shell/connectors/'
    | '/_authed/t/$tenantSlug/_shell/sections/$sectionId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  DevUiRoute: typeof DevUiRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_app': {
      id: '/_authed/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedAppRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/dev/ui': {
      id: '/dev/ui'
      path: '/dev/ui'
      fullPath: '/dev/ui'
      preLoaderRoute: typeof DevUiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/_app/guide': {
      id: '/_authed/_app/guide'
      path: '/guide'
      fullPath: '/guide'
      preLoaderRoute: typeof AuthedAppGuideRouteImport
      parentRoute: typeof AuthedAppRoute
    }
    '/_authed/t/$tenantSlug': {
      id: '/_authed/t/$tenantSlug'
      path: '/t/$tenantSlug'
      fullPath: '/t/$tenantSlug'
      preLoaderRoute: typeof AuthedTTenantSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_app/admin/': {
      id: '/_authed/_app/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAppAdminIndexRouteImport
      parentRoute: typeof AuthedAppRoute
    }
    '/_authed/_app/settings/': {
      id: '/_authed/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedAppSettingsIndexRouteImport
      parentRoute: typeof AuthedAppRoute
    }
    '/_authed/_app/settings/hotkeys': {
      id: '/_authed/_app/settings/hotkeys'
      path: '/settings/hotkeys'
      fullPath: '/settings/hotkeys'
      preLoaderRoute: typeof AuthedAppSettingsHotkeysRouteImport
      parentRoute: typeof AuthedAppRoute
    }
    '/_authed/_app/settings/interface': {
      id: '/_authed/_app/settings/interface'
      path: '/settings/interface'
      fullPath: '/settings/interface'
      preLoaderRoute: typeof AuthedAppSettingsInterfaceRouteImport
      parentRoute: typeof AuthedAppRoute
    }
    '/_authed/t/$tenantSlug/': {
      id: '/_authed/t/$tenantSlug/'
      path: '/'
      fullPath: '/t/$tenantSlug/'
      preLoaderRoute: typeof AuthedTTenantSlugIndexRouteImport
      parentRoute: typeof AuthedTTenantSlugRoute
    }
    '/_authed/t/$tenantSlug/_shell': {
      id: '/_authed/t/$tenantSlug/_shell'
      path: ''
      fullPath: '/t/$tenantSlug'
      preLoaderRoute: typeof AuthedTTenantSlugShellRouteImport
      parentRoute: typeof AuthedTTenantSlugRoute
    }
    '/_authed/_app/admin/organizations/$orgId': {
      id: '/_authed/_app/admin/organizations/$orgId'
      path: '/admin/organizations/$orgId'
      fullPath: '/admin/organizations/$orgId'
      preLoaderRoute: typeof AuthedAppAdminOrganizationsOrgIdRouteImport
      parentRoute: typeof AuthedAppRoute
    }
    '/_authed/t/$tenantSlug/_shell/alarms': {
      id: '/_authed/t/$tenantSlug/_shell/alarms'
      path: '/alarms'
      fullPath: '/t/$tenantSlug/alarms'
      preLoaderRoute: typeof AuthedTTenantSlugShellAlarmsRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/connectors': {
      id: '/_authed/t/$tenantSlug/_shell/connectors'
      path: '/connectors'
      fullPath: '/t/$tenantSlug/connectors'
      preLoaderRoute: typeof AuthedTTenantSlugShellConnectorsRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/documents': {
      id: '/_authed/t/$tenantSlug/_shell/documents'
      path: '/documents'
      fullPath: '/t/$tenantSlug/documents'
      preLoaderRoute: typeof AuthedTTenantSlugShellDocumentsRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/employees': {
      id: '/_authed/t/$tenantSlug/_shell/employees'
      path: '/employees'
      fullPath: '/t/$tenantSlug/employees'
      preLoaderRoute: typeof AuthedTTenantSlugShellEmployeesRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/s/$sectionId': {
      id: '/_authed/t/$tenantSlug/s/$sectionId'
      path: '/s/$sectionId'
      fullPath: '/t/$tenantSlug/s/$sectionId'
      preLoaderRoute: typeof AuthedTTenantSlugSSectionIdRouteImport
      parentRoute: typeof AuthedTTenantSlugRoute
    }
    '/_authed/t/$tenantSlug/_shell/connectors/': {
      id: '/_authed/t/$tenantSlug/_shell/connectors/'
      path: '/'
      fullPath: '/t/$tenantSlug/connectors/'
      preLoaderRoute: typeof AuthedTTenantSlugShellConnectorsIndexRouteImport
      parentRoute: typeof AuthedTTenantSlugShellConnectorsRoute
    }
    '/_authed/t/$tenantSlug/_shell/connectors/$connectorId': {
      id: '/_authed/t/$tenantSlug/_shell/connectors/$connectorId'
      path: '/$connectorId'
      fullPath: '/t/$tenantSlug/connectors/$connectorId'
      preLoaderRoute: typeof AuthedTTenantSlugShellConnectorsConnectorIdRouteImport
      parentRoute: typeof AuthedTTenantSlugShellConnectorsRoute
    }
    '/_authed/t/$tenantSlug/_shell/dashboard/edit': {
      id: '/_authed/t/$tenantSlug/_shell/dashboard/edit'
      path: '/dashboard/edit'
      fullPath: '/t/$tenantSlug/dashboard/edit'
      preLoaderRoute: typeof AuthedTTenantSlugShellDashboardEditRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/devices/calibration': {
      id: '/_authed/t/$tenantSlug/_shell/devices/calibration'
      path: '/devices/calibration'
      fullPath: '/t/$tenantSlug/devices/calibration'
      preLoaderRoute: typeof AuthedTTenantSlugShellDevicesCalibrationRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/devices/categories': {
      id: '/_authed/t/$tenantSlug/_shell/devices/categories'
      path: '/devices/categories'
      fullPath: '/t/$tenantSlug/devices/categories'
      preLoaderRoute: typeof AuthedTTenantSlugShellDevicesCategoriesRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/devices/charts': {
      id: '/_authed/t/$tenantSlug/_shell/devices/charts'
      path: '/devices/charts'
      fullPath: '/t/$tenantSlug/devices/charts'
      preLoaderRoute: typeof AuthedTTenantSlugShellDevicesChartsRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/devices/config': {
      id: '/_authed/t/$tenantSlug/_shell/devices/config'
      path: '/devices/config'
      fullPath: '/t/$tenantSlug/devices/config'
      preLoaderRoute: typeof AuthedTTenantSlugShellDevicesConfigRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/devices/info': {
      id: '/_authed/t/$tenantSlug/_shell/devices/info'
      path: '/devices/info'
      fullPath: '/t/$tenantSlug/devices/info'
      preLoaderRoute: typeof AuthedTTenantSlugShellDevicesInfoRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/devices/locations': {
      id: '/_authed/t/$tenantSlug/_shell/devices/locations'
      path: '/devices/locations'
      fullPath: '/t/$tenantSlug/devices/locations'
      preLoaderRoute: typeof AuthedTTenantSlugShellDevicesLocationsRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/monitoring/devices': {
      id: '/_authed/t/$tenantSlug/_shell/monitoring/devices'
      path: '/monitoring/devices'
      fullPath: '/t/$tenantSlug/monitoring/devices'
      preLoaderRoute: typeof AuthedTTenantSlugShellMonitoringDevicesRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/monitoring/physical': {
      id: '/_authed/t/$tenantSlug/_shell/monitoring/physical'
      path: '/monitoring/physical'
      fullPath: '/t/$tenantSlug/monitoring/physical'
      preLoaderRoute: typeof AuthedTTenantSlugShellMonitoringPhysicalRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/monitoring/virtual': {
      id: '/_authed/t/$tenantSlug/_shell/monitoring/virtual'
      path: '/monitoring/virtual'
      fullPath: '/t/$tenantSlug/monitoring/virtual'
      preLoaderRoute: typeof AuthedTTenantSlugShellMonitoringVirtualRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
    '/_authed/t/$tenantSlug/_shell/sections/$sectionId/edit': {
      id: '/_authed/t/$tenantSlug/_shell/sections/$sectionId/edit'
      path: '/sections/$sectionId/edit'
      fullPath: '/t/$tenantSlug/sections/$sectionId/edit'
      preLoaderRoute: typeof AuthedTTenantSlugShellSectionsSectionIdEditRouteImport
      parentRoute: typeof AuthedTTenantSlugShellRoute
    }
  }
}

interface AuthedAppRouteChildren {
  AuthedAppGuideRoute: typeof AuthedAppGuideRoute
  AuthedAppSettingsHotkeysRoute: typeof AuthedAppSettingsHotkeysRoute
  AuthedAppSettingsInterfaceRoute: typeof AuthedAppSettingsInterfaceRoute
  AuthedAppAdminIndexRoute: typeof AuthedAppAdminIndexRoute
  AuthedAppSettingsIndexRoute: typeof AuthedAppSettingsIndexRoute
  AuthedAppAdminOrganizationsOrgIdRoute: typeof AuthedAppAdminOrganizationsOrgIdRoute
}

const AuthedAppRouteChildren: AuthedAppRouteChildren = {
  AuthedAppGuideRoute: AuthedAppGuideRoute,
  AuthedAppSettingsHotkeysRoute: AuthedAppSettingsHotkeysRoute,
  AuthedAppSettingsInterfaceRoute: AuthedAppSettingsInterfaceRoute,
  AuthedAppAdminIndexRoute: AuthedAppAdminIndexRoute,
  AuthedAppSettingsIndexRoute: AuthedAppSettingsIndexRoute,
  AuthedAppAdminOrganizationsOrgIdRoute: AuthedAppAdminOrganizationsOrgIdRoute,
}

const AuthedAppRouteWithChildren = AuthedAppRoute._addFileChildren(
  AuthedAppRouteChildren,
)

interface AuthedTTenantSlugShellConnectorsRouteChildren {
  AuthedTTenantSlugShellConnectorsConnectorIdRoute: typeof AuthedTTenantSlugShellConnectorsConnectorIdRoute
  AuthedTTenantSlugShellConnectorsIndexRoute: typeof AuthedTTenantSlugShellConnectorsIndexRoute
}

const AuthedTTenantSlugShellConnectorsRouteChildren: AuthedTTenantSlugShellConnectorsRouteChildren =
  {
    AuthedTTenantSlugShellConnectorsConnectorIdRoute:
      AuthedTTenantSlugShellConnectorsConnectorIdRoute,
    AuthedTTenantSlugShellConnectorsIndexRoute:
      AuthedTTenantSlugShellConnectorsIndexRoute,
  }

const AuthedTTenantSlugShellConnectorsRouteWithChildren =
  AuthedTTenantSlugShellConnectorsRoute._addFileChildren(
    AuthedTTenantSlugShellConnectorsRouteChildren,
  )

interface AuthedTTenantSlugShellRouteChildren {
  AuthedTTenantSlugShellAlarmsRoute: typeof AuthedTTenantSlugShellAlarmsRoute
  AuthedTTenantSlugShellConnectorsRoute: typeof AuthedTTenantSlugShellConnectorsRouteWithChildren
  AuthedTTenantSlugShellDocumentsRoute: typeof AuthedTTenantSlugShellDocumentsRoute
  AuthedTTenantSlugShellEmployeesRoute: typeof AuthedTTenantSlugShellEmployeesRoute
  AuthedTTenantSlugShellDashboardEditRoute: typeof AuthedTTenantSlugShellDashboardEditRoute
  AuthedTTenantSlugShellDevicesCalibrationRoute: typeof AuthedTTenantSlugShellDevicesCalibrationRoute
  AuthedTTenantSlugShellDevicesCategoriesRoute: typeof AuthedTTenantSlugShellDevicesCategoriesRoute
  AuthedTTenantSlugShellDevicesChartsRoute: typeof AuthedTTenantSlugShellDevicesChartsRoute
  AuthedTTenantSlugShellDevicesConfigRoute: typeof AuthedTTenantSlugShellDevicesConfigRoute
  AuthedTTenantSlugShellDevicesInfoRoute: typeof AuthedTTenantSlugShellDevicesInfoRoute
  AuthedTTenantSlugShellDevicesLocationsRoute: typeof AuthedTTenantSlugShellDevicesLocationsRoute
  AuthedTTenantSlugShellMonitoringDevicesRoute: typeof AuthedTTenantSlugShellMonitoringDevicesRoute
  AuthedTTenantSlugShellMonitoringPhysicalRoute: typeof AuthedTTenantSlugShellMonitoringPhysicalRoute
  AuthedTTenantSlugShellMonitoringVirtualRoute: typeof AuthedTTenantSlugShellMonitoringVirtualRoute
  AuthedTTenantSlugShellSectionsSectionIdEditRoute: typeof AuthedTTenantSlugShellSectionsSectionIdEditRoute
}

const AuthedTTenantSlugShellRouteChildren: AuthedTTenantSlugShellRouteChildren =
  {
    AuthedTTenantSlugShellAlarmsRoute: AuthedTTenantSlugShellAlarmsRoute,
    AuthedTTenantSlugShellConnectorsRoute:
      AuthedTTenantSlugShellConnectorsRouteWithChildren,
    AuthedTTenantSlugShellDocumentsRoute: AuthedTTenantSlugShellDocumentsRoute,
    AuthedTTenantSlugShellEmployeesRoute: AuthedTTenantSlugShellEmployeesRoute,
    AuthedTTenantSlugShellDashboardEditRoute:
      AuthedTTenantSlugShellDashboardEditRoute,
    AuthedTTenantSlugShellDevicesCalibrationRoute:
      AuthedTTenantSlugShellDevicesCalibrationRoute,
    AuthedTTenantSlugShellDevicesCategoriesRoute:
      AuthedTTenantSlugShellDevicesCategoriesRoute,
    AuthedTTenantSlugShellDevicesChartsRoute:
      AuthedTTenantSlugShellDevicesChartsRoute,
    AuthedTTenantSlugShellDevicesConfigRoute:
      AuthedTTenantSlugShellDevicesConfigRoute,
    AuthedTTenantSlugShellDevicesInfoRoute:
      AuthedTTenantSlugShellDevicesInfoRoute,
    AuthedTTenantSlugShellDevicesLocationsRoute:
      AuthedTTenantSlugShellDevicesLocationsRoute,
    AuthedTTenantSlugShellMonitoringDevicesRoute:
      AuthedTTenantSlugShellMonitoringDevicesRoute,
    AuthedTTenantSlugShellMonitoringPhysicalRoute:
      AuthedTTenantSlugShellMonitoringPhysicalRoute,
    AuthedTTenantSlugShellMonitoringVirtualRoute:
      AuthedTTenantSlugShellMonitoringVirtualRoute,
    AuthedTTenantSlugShellSectionsSectionIdEditRoute:
      AuthedTTenantSlugShellSectionsSectionIdEditRoute,
  }

const AuthedTTenantSlugShellRouteWithChildren =
  AuthedTTenantSlugShellRoute._addFileChildren(
    AuthedTTenantSlugShellRouteChildren,
  )

interface AuthedTTenantSlugRouteChildren {
  AuthedTTenantSlugShellRoute: typeof AuthedTTenantSlugShellRouteWithChildren
  AuthedTTenantSlugIndexRoute: typeof AuthedTTenantSlugIndexRoute
  AuthedTTenantSlugSSectionIdRoute: typeof AuthedTTenantSlugSSectionIdRoute
}

const AuthedTTenantSlugRouteChildren: AuthedTTenantSlugRouteChildren = {
  AuthedTTenantSlugShellRoute: AuthedTTenantSlugShellRouteWithChildren,
  AuthedTTenantSlugIndexRoute: AuthedTTenantSlugIndexRoute,
  AuthedTTenantSlugSSectionIdRoute: AuthedTTenantSlugSSectionIdRoute,
}

const AuthedTTenantSlugRouteWithChildren =
  AuthedTTenantSlugRoute._addFileChildren(AuthedTTenantSlugRouteChildren)

interface AuthedRouteChildren {
  AuthedAppRoute: typeof AuthedAppRouteWithChildren
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedTTenantSlugRoute: typeof AuthedTTenantSlugRouteWithChildren
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAppRoute: AuthedAppRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedTTenantSlugRoute: AuthedTTenantSlugRouteWithChildren,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  DevUiRoute: DevUiRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
